import { set, reduce, cloneDeep, isString, isArray, forEach } from 'lodash';

import actions from 'state/constants';
import initialState from 'state/initialState';
import Filters from 'utils/Filters';

const setCollectionPageData = (state, action) => {
  const { data } = action.payload;

  return {
    ...state,
    ...data,
  };
};

/**
 * This filters out any url param that doesn't have a corresponding configuration in the filtering engine
 */
const _santizeUrlParams = urlParams => {
  const sanitizedParams = {};

  forEach(urlParams, (options, key) => {
    if (Filters.getFilterConfiguration({ filterIdentifier: key })) {
      set(sanitizedParams, key, options);
    }
  });

  return sanitizedParams;
};

const initCollectionPageFilters = (state, action) => {
  const { urlParams } = action.payload;
  const sanitizedUrlParams = _santizeUrlParams(urlParams);
  const filters = cloneDeep(state.filters || {});

  Object.entries(sanitizedUrlParams).forEach(([filterType, filterValue]) => {
    if (isArray(filterValue)) {
      filters[filterType] = {
        options: reduce(
          filterValue,
          (acc, value) => {
            acc[value] = { value: true };

            return acc;
          },
          {}
        ),
      };
    } else if (isString(filterValue)) {
      filters[filterType] = {
        options: {
          [filterValue]: {
            value: true,
          },
        },
      };
    }
  });

  return {
    ...state,
    filters,
  };
};

const setCollectionPageFilter = (state, action) => {
  const { filterIdentifier, option, value } = action.payload;

  const filters = cloneDeep(state.filters || {});

  filters[filterIdentifier] = {
    options: {
      ...filters[filterIdentifier]?.options,
      [option]: {
        value,
      },
    },
  };

  return {
    ...state,
    filters,
  };
};

const expandCollectionPageFilter = (state, action) => {
  const { filterIdentifier } = action.payload;

  const filters = cloneDeep(state.filters || {});

  set(filters, [filterIdentifier, 'isExpanded'], true);

  return {
    ...state,
    filters,
  };
};

const clearCollectionPageFilters = state => {
  const newfilters = cloneDeep(state.filters || {});

  forEach(newfilters, ({ options }) => {
    forEach(options, option => {
      set(option, ['value'], false);
    });
  });

  return {
    ...state,
    filters: newfilters,
  };
};

const openCollectionPageFilterDrawer = state => ({
  ...state,
  isFilterDrawerOpen: true,
});

const closeCollectionPageFilterDrawer = state => ({
  ...state,
  isFilterDrawerOpen: false,
});

const reducer = (state = initialState.collectionPage, action) => {
  switch (action.type) {
    case actions.SET_COLLECTION_PAGE_DATA:
      return setCollectionPageData(state, action);
    case actions.INIT_COLLECTION_PAGE_FILTERS:
      return initCollectionPageFilters(state, action);
    case actions.SET_COLLECTION_PAGE_FILTER:
      return setCollectionPageFilter(state, action);
    case actions.EXPAND_COLLECTION_PAGE_FILTER:
      return expandCollectionPageFilter(state, action);
    case actions.CLEAR_COLLECTION_PAGE_FILTERS:
      return clearCollectionPageFilters(state, action);
    case actions.OPEN_COLLECTION_PAGE_FILTER_DRAWER:
      return openCollectionPageFilterDrawer(state, action);
    case actions.CLOSE_COLLECTION_PAGE_FILTER_DRAWER:
      return closeCollectionPageFilterDrawer(state, action);
    default:
      return state;
  }
};

export default reducer;
